var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sapceLeft search-item date-input",
      on: { click: _vm.chooseDate },
    },
    [
      _c("span", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label) + ":")]),
      _vm._v(" "),
      _c("span", { staticClass: "date-show" }, [
        _vm._v(_vm._s(_vm.dateVal || "All")),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "date-oper" },
        [
          _c("el-date-picker", {
            ref: _vm.id,
            attrs: {
              "value-format": "yyyy-MM-dd",
              type: "date",
              clearable: false,
              placeholder: "All",
            },
            model: {
              value: _vm.dateVal,
              callback: function ($$v) {
                _vm.dateVal = $$v
              },
              expression: "dateVal",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("i", {
        staticClass: "el-icon-circle-close date-close",
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.clearVal()
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }